<template>

    <div class="flex flex-col w-full canvas::editor-admin-ToolbarTop">

        <div class="w-full mb-0">
            <div class="flex flex-wrap">

                <div class="px-5 py-8 sm:px-8 md:flex-1">

                    <div class="flex items-center">
                        <h4 class="inline-block text-xl font-semibold">{{ title }}</h4>

                        <button
                            class="px-2 py-1 ml-3 text-blue-500 rounded hover:bg-gray-50"
                            @click="$emit('update:fullscreen', !fullscreen)">
                            <i
                                class="far"
                                :class="fullscreen ? 'fa-compress-alt' : 'fa-expand-alt'"/>
                        </button>

                    </div>

                    <h6 class="text-gray-400">{{ instruction }}</h6>

                </div>

                <div class="flex px-5 py-8 ml-auto text-right versionInfo sm:px-8">

                    <div>
                        
                        <div class="inline-flex items-center gap-2 md:mr-6" v-if="hasMultipleConceptCanvases[currentLanguageToShow] && hasMultipleConceptCanvases[currentLanguageToShow]['count'] > 1">
                            <div class="label inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                                Meerdere concepten
                            </div>

                            <select class="border-gray-300 rounded-md pl-2 pr-6 py-0.5 text-sm"
                                @change="updateCanvasVersion"
                            >
                                <option v-for="version in hasMultipleConceptCanvases[currentLanguageToShow]['conceptCanvasVersions']"
                                    :key="version.id"
                                    :value="version.id"
                                    :selected="canvasVersion && canvasVersion.id === version.id"
                                >
                                    Versie {{ version.id }}
                                </option>
                            </select>
                        </div>
                        
                        <div
                            class="label inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium"
                            :class="versionState === 'live' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'">
                            {{ versionState | camelcase }}
                        </div>

                        <h6 class="mt-2 mb-0 text-gray-500 card-subtitle" v-if="activeCanvasVersion">
                            {{ versionState === 'live' ? 'Gepubliceerd' : 'Live versie gepubliceerd' }}
                            <template v-if="authorName">door <b>{{ authorName }}</b></template>
                            op <b>{{ activeCanvasVersion.activated_at | date('%d-%m-%Y %H:%M') }}</b>
                        </h6>
                    </div>

                    <div v-if="currentLanguageToShow" class="flex items-center gap-3 ml-4">
                        <i :class="computedIconClass"></i>
                    </div>

                </div>

            </div>
        </div>

    </div>

</template>

<script>

export default {

    props: {
        activeCanvasVersion: Object,
        canvasVersion: Object,
        versionState: String,
        activeMode: String,
        title: String,
        instruction: String,
        currentLanguageToShow: String,
        fullscreen: Boolean,
        hasMultipleConceptCanvases: Object,
    },

    methods: {
        updateCanvasVersion(event) {
            let canvasVersion = this.hasMultipleConceptCanvases[this.currentLanguageToShow]['conceptCanvasVersions']
                .find(version => version.id === parseInt(event.target.value));

            return this.$emit('update:canvasVersion', canvasVersion);
        },
    },

    computed: {

        authorName() {
            return this.canvasVersion.canvas.author?.name;
        },

        computedIconClass() {
            return 'fi fi-' + (this.currentLanguageToShow === 'en' ? 'gb' : this.currentLanguageToShow);
        },

    },

}

</script>

<style lang="scss" scoped>

.canvas\:\:editor-admin-ToolbarTop {
    border-bottom: 1px solid #ddd !important;

    .card-subtitle.mb-0 {
        margin-bottom: 0 !important;
    }

    .flag-icon {
        font-size:  20px;
        margin-top: 3px;
    }

    .versionInfo h6 {
        margin: 5px 0 0 0 !important;
    }

}

</style>
